import { MutationTree } from 'vuex'
import { Auth } from './types'

const MAX_LENGTH_PATH = 100

export const mutations: MutationTree<Auth> = {
  logout(state) {
    state.status = ''
    state.token = ''
    state.tokenValid = false
    state.user = {}
  },

  tokenValid(state, resp) {
    state.tokenValid = resp
  },
  wsConnectionActive(state, payload) {
    state.wsConnectionActive = payload
  },
  setConnection(state, payload) {
    state.connection = payload
  },
  setSession(state, payload) {
    state.session = payload
  }
}
